import * as THREE from 'three';
import Exp from "./Exp";

export default class Camera {
    constructor() {
        this.experience = new Exp();

        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;

        console.log('My Camera');
        switch (this.experience.pageName) {
            case 'home':
                this.setInstanceHome()
                break;
            case 'about':
                this.setInstanceAbout()
                break;
        }
    }

    setInstanceHome() {
        this.instanceGroup = new THREE.Group();
        this.instance = new THREE.PerspectiveCamera(24, this.sizes.width / this.sizes.height, 0.1, 100);
        this.instance.position.z = 12;
        this.instanceGroup.add(this.instance);
        this.scene.add(this.instanceGroup);
    }

    setInstanceAbout() {
        this.instance = new THREE.PerspectiveCamera(75, this.sizes.width / this.sizes.height, 0.1, 100);
        this.instance.position.set(0, 0, 3)
        this.scene.add(this.instance);
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    }
}